import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";

const SuperAdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box p={4}>
      <Typography variant="h4">Super Admin Dashboard</Typography>
      <Button
        variant="contained"
        onClick={() => {
          logout();
          navigate("/login");
        }}
        sx={{ mt: 2 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default SuperAdminDashboard;
